import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'garnet-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Garnet Healthcare',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 8028762300,
  email: 'support@healthfully.app',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/garnet/index.js